import $ from 'jquery';
import FocusTrap from './focustrap';

let $zoom, $close, $image, $widgets, $body, $window, $panControls, zoomWidth, zoomHeight;

const keyCodes = {
        UP: 38,
        DOWN: 40,
        LEFT: 37,
        RIGHT: 39,
        ESC: 27
    },
    PANNING_STEP_COUNT = 4,
    imageZoom = {
        _hide: function(e) {
            if (this._isPanControlButton(e.target)) {
                return;
            }
            var FADE_OUT_MILLISECONDS = 800;
            $widgets.fadeOut(FADE_OUT_MILLISECONDS);
            $window.off('keydown', this._handleKeyDown);
            $body.off('keyup', this._handleKeyUp.bind(this));
        },
        _isPanControlButton: function(target) {
            return target && target.className && /pan/gi.test(target.className);
        },
        _handleKeyDown: function(e) {
            switch (e.keyCode) {
                case keyCodes.UP:
                case keyCodes.DOWN:
                case keyCodes.LEFT:
                case keyCodes.RIGHT:
                    e.preventDefault();
                    break;

                default:
                    break;
            }
        },
        _handleKeyUp: function(e) {
            switch (e.keyCode) {
                case keyCodes.ESC:
                    this._hide(e);
                    break;

                case keyCodes.UP:
                    this._panUp();
                    break;

                case keyCodes.DOWN:
                    this._panDown();
                    break;

                case keyCodes.LEFT:
                    this._panLeft();
                    break;

                case keyCodes.RIGHT:
                    this._panRight();
                    break;

                default:
                    break;
            }
        },
        _show: function(callback) {
            var FADE_IN_MILLISECONDS = 1000;
            $widgets.fadeIn(FADE_IN_MILLISECONDS, callback);
            $window.on('keydown', this._handleKeyDown);
            $body.on('keyup', this._handleKeyUp.bind(this));
        },
        _preload: function(src, callback) {
            if (!src) {
                return;
            }

            var img = new Image();
            // eslint-disable-next-line no-empty-function
            img.onload = callback ? callback : function() {};
            img.src = src;
        },
        _move: function(x, y) {
            $image.css({top: y, left: x});
        },
        _xOffset: function(event) {
            return event.offsetX ? event.offsetX : event.originalEvent.layerX;
        },
        _yOffset: function(event) {
            return event.offsetY ? event.offsetY : event.originalEvent.layerY;
        },
        _position: function(position, zoomDimension, imageDimension) {
            return -(position / zoomDimension) * (imageDimension - zoomDimension);
        },
        // eslint-disable-next-line max-params
        _handleMoveEvent: function(xOffset, yOffset, imageWidth, imageHeight, zoomWidth, zoomHeight) {
            var x = this._position(xOffset, zoomWidth, imageWidth),
                y = this._position(yOffset, zoomHeight, imageHeight);

            if (y > 0) {
                y = 0;
            }

            this._move(x, y);
        },
        _addPanningEventListeners: function($panControls) {
            $panControls
                .off('click')
                .on('click', '.panUp', this._panUp.bind(this))
                .on('click', '.panLeft', this._panLeft.bind(this))
                .on('click', '.panRight', this._panRight.bind(this))
                .on('click', '.panDown', this._panDown.bind(this));
        },
        _panUp: function() {
            var maxTopPosition = $image.height() - zoomHeight,
                topStepIncrement = maxTopPosition / PANNING_STEP_COUNT,
                position = parseFloat($image.css('top')) - topStepIncrement,
                max = -maxTopPosition;

            $image.css('top', position > max ? position : max + 'px');
        },
        _panDown: function() {
            var maxTopPosition = $image.height() - zoomHeight,
                topStepIncrement = maxTopPosition / PANNING_STEP_COUNT,
                position = parseFloat($image.css('top')) + topStepIncrement;

            $image.css('top', position < 0 ? position : 0 + 'px');
        },
        _panLeft: function() {
            var maxLeftPosition = $image.width() - zoomWidth,
                leftStepIncrement = maxLeftPosition / PANNING_STEP_COUNT,
                position = parseFloat($image.css('left')) + leftStepIncrement;

            $image.css('left', position < 0 ? position : 0 + 'px');
        },
        _panRight: function() {
            var maxLeftPosition = $image.width() - zoomWidth,
                leftStepIncrement = maxLeftPosition / PANNING_STEP_COUNT,
                position = parseFloat($image.css('left')) - leftStepIncrement,
                max = -maxLeftPosition;

            $image.css('left', position > max ? position : max + 'px');
        },
        init: function($container, options) {
            if (!$container) {
                throw new Error('imageZoom requires a container element');
            }

            var focusTrap;

            $($container)
                .on(
                    'click',
                    '.zoomable',
                    function(e) {
                        e.preventDefault();

                        var src = e.currentTarget.firstElementChild.dataset.image;

                        $zoom = document.getElementById('frame');

                        if (!$zoom) {
                            $zoom = $(
                                '<div id="frame"><div id="zoomShield">&nbsp;</div><img id="zoom" src="" /></div>'
                            ).prependTo($container);
                            $close = $(
                                '<a href="#" id="zoomClose" style="display:none;" class="ignore-move">Close <img src="/images/productClass/zoomCloseX.png" width="28" height="28" alt="" class="ignore-move" /></a>'
                            ).prependTo($zoom);

                            $panControls = $(
                                '<div id="panControls">' +
                                    '<button class="panUp" aria-label="Pan image up">&uarr;</button>' +
                                    '<button class="panLeft" aria-label="Pan image left">&larr;</button>' +
                                    '<button class="panDown" aria-label="Pan image down">&darr;</button>' +
                                    '<button class="panRight" aria-label="Pan image right">&rarr;</button>' +
                                    '</div>'
                            ).appendTo($zoom);

                            $image = $zoom.find('#zoom');
                            $widgets = $zoom.add($close);
                            $body = $('body');
                            $window = $(window);
                            zoomWidth = $zoom.width();
                            zoomHeight = $zoom.height();

                            if(options && options.height){
                                zoomHeight = options.height;
                                $zoom.css({height: `${options.height}px`});
                            }

                            focusTrap = new FocusTrap($zoom.get(0), e.currentTarget);
                        }

                        this._preload(
                            src,
                            function() {
                                $image.attr('src', src);
                                this._show(
                                    function() {
                                        if (typeof focusTrap !== 'undefined') {
                                            focusTrap.enable();
                                        }
                                        this._addPanningEventListeners($panControls);
                                    }.bind(this)
                                );
                            }.bind(this)
                        );
                    }.bind(this)
                )
                .on(
                    'mouseenter touchstart',
                    function(e) {
                        this._preload($(e.target).data('image'));
                    }.bind(this)
                )
                .on(
                    'click',
                    '#zoomClose',
                    function(e) {
                        e.preventDefault();
                        this._hide(e);

                        if (focusTrap) {
                            focusTrap.disable();
                        }
                    }.bind(this)
                )
                .on(
                    'mousemove touchmove',
                    '#frame',
                    function(e) {
                        e.preventDefault();
                        if (/pan/gi.test(e.target.className) || /pan/gi.test(e.target.id) || e.target.className === 'ignore-move') {
                            return;
                        }

                        this._handleMoveEvent(
                            this._xOffset(e),
                            this._yOffset(e),
                            $image.width(),
                            $image.height(),
                            zoomWidth,
                            zoomHeight
                        );
                    }.bind(this)
                )
                .on('#frame', 'click', function(e) {
                    e.stopPropagation();
                });
        }
    };

export default imageZoom;
